'use strict';

const Wysiwyg = {
    els: null,
    toggle: null,
    init: function () {
    }
};

export default Wysiwyg;
